<template>
  <v-row
    no-gutters
    class="reschedule"
  >
    <v-container v-if="!loaded">
      <v-layout
        fill-height
        align-center
        justify-center>
        <v-flex xs12><dashboard-loader /></v-flex>
      </v-layout>
    </v-container>
    <v-container
      v-if="loaded"
      v-show="loaded && !rescheduled"
      :class="isEmbedded ? 'pt-0' : 'reschedule__Container pt-0 Clock'">
      <v-col
        :class="isMobile ? 'px-0 pt-0' : 'offset-md-1 pt-0'"
        md="10"
        sm="12">
        <v-card

          class="elevation-0">
          <!-- Reschedule top fixed roolbar -->
          <reschedule-toolbar
            :timezone="meeting.timezone"
            :start-date="meetingStartDate"
            :end-date="meetingEndDate"
            :is-embedded="isEmbedded"
            :class="isMobile ? 'mb-3' : ''"/>
          <!-- Title if Default Theme-->
          <v-col
            :class="!isEmbedded ? '' : 'pb-0'"
            cols="12"
            sm="12">

            <v-col
              :class="!isEmbedded ? 'pt-0' : 'pa-1'"
              cols="12">
              <h1
                :class="!isEmbedded ? 'headline black--text text-center font-weight-medium mb-1' : 'black--text text-center font-weight-medium subtitle-1 mb-0'">
                {{ selectedMeetingType.meetingTitle }}
              </h1>
              <div
                :class="!isEmbedded ? 'body-1 grey--text text--darken-3 my-4' : 'body-2 grey--text darken-3'"
                cols="12">
                <span
                  :class="selectedMeetingType.description && selectedMeetingType.description.length > 140 ? 'text-left' : 'text-center'"
                  class="d-block ReschedulePage__description-span">{{ selectedMeetingType.description }}</span>
              </div>
            </v-col>

          </v-col>
          <v-row
            :class="isEmbedded ? 'ReschedulePage ma-4' : 'ReschedulePage'"
            class="border--radius-box"
            no-gutters
            wrap
            d-inline-flex
          >
            <v-col
              sm="12"
              cols="12">
              <meeting-header-info
                :location="meeting.location"
                :duration="selectedMeetingType.duration"
                :host-picture="selectedMeetingType.pictureUrl"
                :host-name="fullName(selectedMeetingType.firstName, selectedMeetingType.lastName)"
                :is-embedded="isEmbedded"/>
            </v-col>
            <v-col
              cols="12"
              sm="12">
              <v-divider/>
              <v-card-text class="ReschedulePage__slotList pa-0">
                <!-- Slots List -->
                <slot-list
                  :is-embedded="isEmbedded"
                  :reschedule-slot="meetingStartDateTimestamp"
                  :reschedule-slot-end="meetingEndDateTimestamp"
                  :is-saving="isSavingSlot"
                  @slotSelected="reschedule"/>
              </v-card-text>
            </v-col>
          </v-row>
          <!-- Footer Powered By -->
          <powered-by
            :display-text="!settings || !settings.whiteLabel"/>
        </v-card>
      </v-col>
    </v-container>
    <v-container v-if="loaded && rescheduled">
      <v-row no-gutters>
        <v-col
          md="10"
          sm="12"
          class="offset-md-1">
          <v-card
            flat>
            <v-card-text class="pa-0">
              <booked
                :white-label="settings.whiteLabel"
                :is-embedded="isEmbedded"
                @reschedule="refresh"/>
            </v-card-text>
            <powered-by
              :display-text="!settings || !settings.whiteLabel"/>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar
        v-if="loaded && !rescheduled"
        v-model="snackbar"
        :timeout="10000"
        left>
        {{ $t('snackBar.reschedule') }}
      </v-snackbar>
    </v-container>
  </v-row>
</template>

<script>
import { userMixin, localeMixin, snackbarMixin, isMobileMixin } from '../mixins'
import { mapGetters } from 'vuex'
import Booked from './Booked.vue'
import DashboardLoader from './Loader.vue'
import SlotList from './SlotList.vue'
import PoweredBy from './PoweredBy.vue'
import moment from 'moment'
import MeetingHeaderInfo from './MeetingHeaderInfo.vue'
import RescheduleToolbar from './RescheduleToolbar.vue'

export default {
  components: {
    Booked,
    DashboardLoader,
    MeetingHeaderInfo,
    PoweredBy,
    RescheduleToolbar,
    SlotList
  },
  mixins: [userMixin, localeMixin, snackbarMixin, isMobileMixin],
  data () {
    return {
      isEmbedded: null,
      isSavingSlot: false,
      loaded: false,
      meeting: null,
      meetingStartDateTimestamp: null,
      meetingEndDateTimestamp: null,
      meetingStartDate: null,
      meetingEndDate: null,
      rescheduled: false,
      settings: null,
      slotStart: '',
      slotEnd: '',
      snackbar: true
    }
  },
  computed: {
    ...mapGetters('meetings', [
      'selectedMeetingType',
      'meetingCalendars'
    ])
  },

  async mounted () {
    try {
      const meetingTypeData = await this.$store.dispatch('meetings/getMeetingTypeByUrl', this.$route.params)
      if (!meetingTypeData) {
        this.$router.push({ name: 'notFound' })
        return
      }
      if (this.$route.query && this.$route.query.m && this.$route.query.i && this.$route.query.s && this.$route.query.e && this.$route.query.sec) {
        const start = this.$route.query.s
        const end = this.$route.query.e
        if (moment.unix(start).isValid() && moment.unix(end).isValid()) {
          const meetingIdEnc = this.$route.query.m
          const params = {
            inv: this.$route.query.i,
            startTS: start,
            endTS: end,
            secret: this.$route.query.sec
          }
          const payload = { meetingIdEnc, params }
          const meetingInfo = await this.$store.dispatch('meetings/getMeeting', payload)
          this.settings = await this.$store.dispatch('meetings/getGeneralSettings', this.$route.params.prefixMeetingUrl)
          this.meeting = meetingInfo.meeting
          this.meetingStartDateTimestamp = parseInt(start)
          this.meetingEndDateTimestamp = parseInt(end)
          this.meetingStartDate = moment.unix(start).tz(this.meeting.timezone)
          this.meetingEndDate = moment.unix(end).tz(this.meeting.timezone)
        } else {
          throw new Error('times not valid')
        }
      } else {
        throw new Error('params not valid')
      }
      if (this.$route.query && this.$route.query.embed) {
        this.isEmbedded = this.$route.query.embed
      }
      this.loaded = true
    } catch (err) {
      console.log(err)
      this.$router.push({ name: 'notFound' })
    }
  },
  methods: {
    async reschedule (newSlot) {
      this.isSavingSlot = true
      this.slotStart = newSlot.startTimestamp.toString()
      this.slotEnd = newSlot.endTimestamp.toString()
      try {
        const body = {
          inv: this.$route.query.i,
          startTS: this.$route.query.s,
          endTS: this.$route.query.e,
          newStartTS: this.slotStart,
          newEndTS: this.slotEnd,
          secret: this.$route.query.sec
        }
        const payload = { meetingIdEnc: this.$route.query.m, body }
        const rescheduled = await this.$store.dispatch('meetings/rescheduleMeeting', payload)
        this.meeting = rescheduled.meeting
        this.rescheduled = true
        this.isSavingSlot = false
      } catch (err) {
        console.log(err)
        this.openSnackbarError()
      }
    },
    refresh () {
      this.$router.go()
    }
  }
}
</script>
<style lang="scss">

.reschedule {
  min-height:100vh;
  &__Container {
    &__slotList {
      max-height: 55vh;
      overflow-y: scroll;
    }
  }
}
.ReschedulePage {
  border: 1px solid #dedede;
  &__slotList {
    max-height: 50vh;
    overflow-y: scroll;

    @media screen and (max-width: $screen-xs) {
      max-height: 40vh ;
    }
  }
  &__description-span {
    white-space: pre-wrap;
  }
}

</style>
